import { Fragment, useState } from 'react';
import { useTheme } from 'styled-components';
import Label from '../Label/Label';
import { ThemeType } from '../../../../theme/themeType';

export type HiddenDetailTagItem = {
  key: string;
  node: JSX.Element;
};

type Props = {
  items: HiddenDetailTagItem[];
  label?: string;
};

function HiddenDetails({ items, label = 'More details...' }: Props): JSX.Element | null {
  const theme = useTheme() as ThemeType;
  const [showHiddenDetails, setShowHiddenDetails] = useState(false);

  if (items.length === 0) {
    return null;
  }

  return (
    <>
      <div
        style={{
          border: `1px solid ${showHiddenDetails ? theme.colors.main_cta : 'transparent'}`,
          borderRadius: '6px',
        }}
      >
        <Label
          label={label}
          onClick={() => setShowHiddenDetails((prev) => !prev)}
        />
      </div>
      {showHiddenDetails && items.map((item) => (
        <Fragment key={item.key}>
          {item.node}
        </Fragment>
      ))}
    </>
  );
}

export default HiddenDetails;
